<script lang="ts" setup>
import { DELIVERY_PAYMENT_URLS } from '~/composables/constants/footer'

import MastercardIcon from '@/assets/icons/payment/mastercard.png'
import PaypalIcon from '@/assets/icons/payment/paypal.png'
import PayseraIcon from '@/assets/icons/payment/paysera.png'
import VisaIcon from '@/assets/icons/payment/visa.png'

import AecIcon from '@/assets/icons/delivery/aec.png'
import DpdIcon from '@/assets/icons/delivery/dpd.png'
import OmnivaIcon from '@/assets/icons/delivery/omniva.png'

import CountriesEnum from '~/enums/CountriesEnum'
import getDefaultCountryId from '~/utils/countries/getDefaultCountryId'

const defaultCountryId = getDefaultCountryId() as CountriesEnum
const { isTarpininke, isWhitelabel } = useTheme()
const { t } = useLang()

const currentSiteUrls = computed(() => DELIVERY_PAYMENT_URLS[defaultCountryId])
</script>

<template>
  <div class="payment-and-delivery flex justify-between flex-wrap">
    <ul>
      <li class="mb-8">
        <p class="mb-4">{{ t('footer.secure-payment') }}:</p>
        <div class="flex flex-wrap gap-[10px]">
          <a :href="currentSiteUrls.visa" class="logo-link-wrap" target="_blank" title="Visa">
            <span class="logo-link" :style="{ 'background-image': `url(${VisaIcon})` }" />
          </a>
          <a :href="currentSiteUrls.paysera" class="logo-link-wrap" target="_blank" title="Paysera">
            <span class="logo-link" :style="{ 'background-image': `url(${PayseraIcon})` }" />
          </a>
          <a
            v-if="!isTarpininke && !isWhitelabel"
            :href="currentSiteUrls.paypal"
            class="logo-link-wrap"
            target="_blank"
            title="PayPal">
            <span class="logo-link" :style="{ 'background-image': `url(${PaypalIcon})` }" />
          </a>
          <a :href="currentSiteUrls.mastercard" class="logo-link-wrap" target="_blank" title="MasterCard">
            <span class="logo-link" :style="{ 'background-image': `url(${MastercardIcon})` }" />
          </a>
        </div>
      </li>
      <li class="mb-8">
        <p class="mb-4">{{ t('footer.reliable-shopping') }}:</p>
        <div class="flex flex-wrap gap-[10px]">
          <a v-if="!isWhitelabel" :href="currentSiteUrls.dpd" target="_blank" class="logo-link-wrap" title="DPD">
            <span class="logo-link" :style="{ 'background-image': `url(${DpdIcon})` }" />
          </a>
          <a v-if="!isWhitelabel" :href="currentSiteUrls.omniva" target="_blank" class="logo-link-wrap" title="Omniva">
            <span class="logo-link" :style="{ 'background-image': `url(${OmnivaIcon})` }" />
          </a>
          <a :href="currentSiteUrls.aec" target="_blank" class="logo-link-wrap" title="AEC">
            <span class="logo-link" :style="{ 'background-image': `url(${AecIcon})` }" />
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="postcss" scoped>
.payment-and-delivery {
  p {
    @apply text-base font-semibold;
  }

  .logo-link-wrap {
    @apply rounded-[0.1875rem] w-[60px] h-[32px] bg-white p-1;

    .logo-link {
      @apply flex w-full h-full bg-contain bg-center bg-no-repeat;
    }
  }
}

.nl {
  .payment-and-delivery {
    p {
      @apply text-text1 dark:text-dmText1;
    }
  }
}
</style>
